var restorepasswordmanual = {
    restore: "CAMBIAR CONTRASEÑA",
    eyebrowLabel: "Actualización segura de contraseña",
    text1: "Ingresa tu nueva contraseña",
    text2: "Crea una contraseña segura para proteger tu cuenta.",
    panelTitle: "Define tu nueva contraseña",
    panelText: "Usa al menos 8 caracteres y asegúrate de que ambos campos coincidan antes de guardar el cambio.",
    login: "Ingresa nuevamente",
    newpass: "Contraseña Nueva:",
    renewpass: "Confirmar contraseña:",
    newpassPlaceholder: "Ingresa tu nueva contraseña",
    renewpassPlaceholder: "Confirma tu nueva contraseña",
    sendbtn: "Guardar",
    saving: "Guardando...",
    error: "error: Confirmar contraseña no coincide",
    msg: "Su contraseña ha sido cambiada, vaya a Iniciar sesión para obtener acceso nuevamente",
    loginbtn: "Ingresa nuevamente",
    errorpage: "ERROR EN LA PAGINA",
    errortext1: "Ha ocurrido un error",
    errorgo: "Porfavor haz click aquí:",
    errorbtn: "Intentalo nuevamente",
    requiredNewPassword: "La nueva contraseña es obligatoria.",
    requiredRepeatPassword: "Confirma tu nueva contraseña.",
    passwordMinLength: "La contraseña debe tener al menos 8 caracteres.",
    passwordMismatch: "Las contraseñas no coinciden.",
    genericError: "No pudimos actualizar tu contraseña en este momento. Inténtalo nuevamente más tarde.",
    successTitle: "Contraseña actualizada",
    successText: "Tu contraseña se cambió correctamente. Ahora puedes volver a iniciar sesión con tu nueva contraseña.",
    successHelp: "Por seguridad, usa tu nueva contraseña la próxima vez que ingreses.",
    invalidLinkTitle: "No pudimos preparar el cambio de contraseña",
    invalidLinkText: "Ocurrió un problema al cargar la información necesaria para actualizar tu contraseña.",
    invalidLinkHelp: "Inténtalo de nuevo desde tu cuenta o vuelve a iniciar sesión si es necesario.",
    loadingTitle: "Preparando el cambio de contraseña",
    loadingText: "Espera un momento mientras validamos tu acceso."
}
module.exports = restorepasswordmanual
